import React from 'react';
import { View, StyleSheet, ScrollView, Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import TopBar from './TopBar';
import { useTheme } from '../../theme/ThemeContext';

interface AppShellProps {
  title?: string;
  showLogo?: boolean;
  children: React.ReactNode;
  scrollable?: boolean;
  showBackButton?: boolean;
  onBackPress?: () => void;
  rightActions?: React.ReactNode;
  showTopBar?: boolean;
}

const AppShell: React.FC<AppShellProps> = ({ title, showLogo = false, children, scrollable = true, showBackButton = false, onBackPress, rightActions, showTopBar = true }) => {
  const { theme } = useTheme();
  
  return (
    <SafeAreaView style={[styles.container, { backgroundColor: theme.background }]} edges={Platform.OS === 'ios' ? [] : ['left', 'right']}>
      {showTopBar && <TopBar title={title} showLogo={showLogo} showBackButton={showBackButton} onBackPress={onBackPress} rightActions={rightActions} />}
      {scrollable ? (
        <ScrollView 
          style={styles.content}
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={true}
        >
          {children}
        </ScrollView>
      ) : (
        <View style={styles.content}>
          {children}
        </View>
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
  },
});

export default AppShell;
